import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  isFetching: false,
  hasFetched: false,
  SSOid: null, // place on top level to prevent nested access
  data: {},
  bankStatus: null,
  transactStatus: {},
  transactFetching: false
};

export default function profile (state = initialState, action) {
  switch (action.type) {
  case types.PROFILE_REQUEST:
    return _.merge({}, state, {
      isFetching: true
    });

  case types.PROFILE_SUCCESS:
    return _.merge({}, state, {
      isFetching: false,
      hasFetched: true,
      data: action.profile,
      SSOid: action.profile.SSOid
    });

  case types.PROFILE_FAILURE:
    return _.merge({}, state, {
      isFetching: false,
      hasFetched: true
    });

  case types.PROFILE_TRANSACT_REQUEST:
    return _.merge({}, state, {
      transactFetching: true
    });

  case types.PROFILE_TRANSACT_SUCCESS:
    return _.merge({}, state, {
      transactStatus: action.transactStatus,
      transactFetching: false
    });

  case types.PROFILE_TRANSACT_FAILURE:
    return _.merge({}, state, {
      transactFetching: false
    });

  case types.PROFILE_UPDATE_SUCCESS:
    return _.merge({}, state, {
      isFetching: false,
      data: action.profile
    });

  case types.PROFILE_UPDATE_FAILURE:
    return _.merge({}, state, {
      isFetching: false,
      error: action.error
    });

  case types.RESET_ENV:
    return _.merge({}, initialState);

  case types.FAVORITED_LISTINGS_FETCH_SUCCESS:
    return _.assign({}, state, {
      favoritedListings: action.response.attachments
    });

  case types.BANK_STATUS_SUCCESS:
    return _.merge({}, state, {
      bankStatus: action.bankStatus
    });

  default:
    return state;
  }
}
